import { useAppDispatch } from '@/shared/hooks';

import { accessModel } from '@/entities/access';
import { patientModel } from '@/entities/patient';

export const useAcceptSharingPatientInvite = () => {
  const dispatch = useAppDispatch();

  return async ({
    invitationID,
    accessCode,
  }: {
    invitationID: string;
    accessCode: string;
  }) => {
    const { Sharing, Patient } = await dispatch(
      accessModel.thunks.acceptSharing({
        SharingID: invitationID,
        Secret: accessCode,
      }),
    ).unwrap();

    if (Patient) {
      dispatch(patientModel.actions.setNewestOne(Patient));
    }

    if (Sharing) {
      dispatch(accessModel.sharingActions.setNewestOne(Sharing));
    }

    return {
      acceptedInvitationStatus: Sharing?.Status,
      sharedPatientID: Patient?.ID,
    };
  };
};
